import { render, staticRenderFns } from "./rockblockTrap.vue?vue&type=template&id=46fc02f5&"
import script from "./rockblockTrap.vue?vue&type=script&lang=js&"
export * from "./rockblockTrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports